import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ResetPasswordRequestService } from './reset-password-request.service';

@Component({
  selector: 'app-reset-password-request',
  templateUrl: './reset-password-request.component.html',
  styleUrls: ['./reset-password-request.component.scss']
})
export class ResetPasswordRequestComponent {
  form = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  success = false;
  error = '';

  constructor(private fb: FormBuilder, private http: HttpClient, private resetPasswordRequest: ResetPasswordRequestService) {}

  onSubmit(): void {
    const email = this.form.value.email;
  
    if (!email) {
      this.error = 'Veuillez fournir une adresse e-mail.';
      this.success = false;
      return;
    }
  
    this.resetPasswordRequest.requestResetLink(email).subscribe({
      next: () => {
        this.success = true;
        this.error = '';
      },
      error: (err) => {
        this.success = false;
        this.error = err?.error?.error?.message || "❌ Une erreur est survenue. Veuillez réessayer.";
      }
    });
  }
  
}
